import { useMemo } from 'react';
import { Table } from 'antd';
import { TableProps } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import { StyledTableHeaderCell, StyledTableWrapper } from 'components/new-ui/base/table/styles';
import { ICS2ArrivalView } from 'store/declarations/eu/ics2/arrival/ics2-arrival-notification-declaration';
import getArrivalNotificationColumns from 'views/custom-declaration/declaration-table/ArrivalNotificationColumns';

type Props = TableProps<ICS2ArrivalView> & {
    showManifestId?: boolean;
};

const ArrivalNotificationsTable = ({ showManifestId = true, ...rest }: Props) => {
    const navigate = useNavigate();

    const columns = useMemo(() => getArrivalNotificationColumns({ showManifestId }), [showManifestId]);

    return (
        <StyledTableWrapper>
            <Table<ICS2ArrivalView>
                rowKey="id"
                columns={columns}
                components={{
                    header: {
                        cell: (props: any) => <StyledTableHeaderCell {...props} />,
                    },
                }}
                onRow={(record) => ({
                    'data-testid': 'arrival-notification-table-row',
                    style: { cursor: 'pointer' },
                    onClick: () => navigate(`/arrival-notifications/${record.id}`),
                })}
                {...rest}
            />
        </StyledTableWrapper>
    );
};

export default ArrivalNotificationsTable;
